import { Box, Button, Grid, MenuItem, Paper, Stack, Typography, FormLabel, InputAdornment } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import AutoSuggestion from "../../components/autocomplete";
import NormalInput from "../../components/inputs/normalInput";
import BasicSelect from "../../components/select";
import { SUBSCRIPTION_TYPE, FORM_TEXTFIELD_STYLES } from "../../utils/constant";
import { ROUTES } from "../../utils/routes";
import { assignInfluencerSubscription, getInfluencersForDropdown, getInfluencerPlanDetails, getAllInfluencerSubscriptionTypes } from "./action";
import NumberInput from "../../components/inputs/normalInput/number";

const AddInfluencerSubscription = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [influencerOptions, setInfluencerOptions] = useState([]);
    const [subscriptionTypes, setSubscriptionTypes] = useState([]);
    console.log(subscriptionTypes);

    const initialValues = {
        influencerId: "",
        type: "",
        startDate: "",
        endDate: "",
        price: "",
        paid: "",
        barter: "",
        affiliate: "",
        performance: ""
    };

    const validationSchema = Yup.object({
        influencerId: Yup.string().required("Influencer is required"),
        type: Yup.string().required("Plan Type is required"),
        planCost: Yup.number().typeError("Must be a number").required("Plan Cost is required"),
        startDate: Yup.string().required("Start Date is required"),
        endDate: Yup.string().required("End Date is required"),
        paid: Yup.number().typeError("Must be a number").required("Paid Quota is required"),
        barter: Yup.number().typeError("Must be a number").required("Barter Quota is required"),
        affiliate: Yup.number().typeError("Must be a number").required("Affiliate Quota is required"),
        performance: Yup.number().typeError("Must be a number").required("Performance Quota is required"),
    });

    const handleInfluencerSearch = (value) => {
        console.log(value);
        dispatch(getInfluencersForDropdown(value, setInfluencerOptions));
    };

    // Initial fetch
    useEffect(() => {
        handleInfluencerSearch("");
        dispatch(getAllInfluencerSubscriptionTypes(setSubscriptionTypes));
    }, []);

    const handleSubmit = (values) => {
        const payload = {
            ...values,
            influencerId: values.influencerId?.id || values.influencerId,
        };
        dispatch(assignInfluencerSubscription(payload, navigate));
    };

    return (
        <>
            <Stack direction={"row"} alignItems={"center"} spacing={3} mb={2}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} sx={{ minHeight: '42px', paddingX: '16px', width: '100%' }}>
                    <Typography variant="h1" className="page-title">
                        Assign Influencer Subscription
                    </Typography>
                    <Button variant="outlined" onClick={() => navigate(ROUTES.INFLUENCER_SUBSCRIPTION_LIST)}>
                        Back
                    </Button>
                </Stack>
            </Stack>

            <Paper sx={{ p: 3, m: 2 }}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, handleChange, setFieldValue, submitForm }) => (
                        <>
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit(values);
                            }} >
                                <div className='card p-4' style={{ marginLeft: '16px', marginRight: '16px' }}>
                                    <Grid container spacing={2}>

                                        <Grid item xs={12} lg={4} md={4} sm={4}>
                                            <BasicSelect
                                                label="Plan Type"
                                                name="type"
                                                defaultValue={values.type}
                                                handleChange={(e, value) => {
                                                    const type = e.target.value;
                                                    console.log(type);
                                                    setFieldValue("type", type);
                                                    if (type === "custom") {
                                                        setFieldValue("startDate", "");
                                                        setFieldValue("endDate", "");
                                                        setFieldValue("planCost", "");
                                                        setFieldValue("paid", "");
                                                        setFieldValue("barter", "");
                                                        setFieldValue("affiliate", "");
                                                        setFieldValue("performance", "");
                                                    } else {
                                                        const selectedType = subscriptionTypes.find(t => t.type === type);
                                                        if (selectedType) {
                                                            setFieldValue("planCost", selectedType.price);
                                                            setFieldValue("paid", selectedType.paid_quota);
                                                            setFieldValue("barter", selectedType.barter_quota);
                                                            setFieldValue("affiliate", selectedType.affiliate_quota);
                                                            setFieldValue("performance", selectedType.performance_quota);

                                                            const today = new Date();
                                                            const endDate = new Date(today);
                                                            endDate.setDate(endDate.getDate() + (selectedType.duration_days || 0));

                                                            setFieldValue("startDate", today.toISOString().split('T')[0]);
                                                            setFieldValue("endDate", endDate.toISOString().split('T')[0]);
                                                        }
                                                    }
                                                }}
                                                error={touched.type && Boolean(errors.type)}
                                            // helperText={touched.type && errors.type}
                                            >
                                                {subscriptionTypes.map((item) => (
                                                    <MenuItem key={item.type} value={item.type}>
                                                        {item.type}
                                                    </MenuItem>
                                                ))}
                                                <MenuItem value="custom">Custom</MenuItem>
                                            </BasicSelect>
                                        </Grid>
                                        <Grid item xs={12} lg={4} md={4} sm={4}>
                                            <FormLabel>Influencer</FormLabel>
                                            <AutoSuggestion
                                                options={influencerOptions}
                                                getOptionLabel={(option) => option.name || ""}
                                                placeholder="Search Influencer Name"
                                                onChange={(e, val) => setFieldValue("influencerId", val?.id)}
                                                onInputChange={(event, value) => handleInfluencerSearch(value)}
                                                error={touched.influencerId && Boolean(errors.influencerId)}
                                                helperText={touched.influencerId && errors.influencerId}
                                            />
                                        </Grid>


                                        <Grid item xs={12} lg={4} md={4} sm={4}>
                                            <FormLabel required>Plan Cost</FormLabel>
                                            <NumberInput
                                                startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
                                                startAdornment={true}
                                                placeholder={"Please enter plan cost here.."}
                                                name={"planCost"}
                                                isRequired={false}
                                                type={"number"}
                                                isDisabled={!values.type || values.type !== 'custom'}
                                                onWheel={(e) => e.target.blur()}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.planCost}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 10) {
                                                        handleChange(e);
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}

                                                error={Boolean(touched.planCost) && errors.planCost}
                                                helperText={touched.planCost && errors.planCost}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={4} md={4} sm={4}>
                                            <FormLabel required>Start Date</FormLabel>
                                            <NormalInput
                                                name={"startDate"}
                                                type={"date"}
                                                focused={false}
                                                isRequired={false}
                                                isDisabled={!values.type || values.type !== 'custom'}
                                                label={""}
                                                min={new Date().toISOString().split('T')[0]}
                                                sizeval="medium"
                                                defaultValue={values?.startDate}
                                                values={values?.startDate}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    if (values.endDate) {
                                                        const startDate = new Date(
                                                            e.target.value
                                                        );
                                                        const endDate = new Date(values.endDate);
                                                        if (!(endDate >= startDate)) {

                                                            handleChange({
                                                                target: {
                                                                    name: "endDate",
                                                                    value: e.target.value,
                                                                },
                                                            });
                                                        }
                                                    }
                                                }}

                                                error={
                                                    Boolean(touched.startDate) &&
                                                    errors.startDate
                                                }
                                                helperText={
                                                    touched.startDate && errors.startDate
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={4} md={4} sm={4} >
                                            <FormLabel required>End Date</FormLabel>
                                            <NormalInput
                                                name={"endDate"}
                                                type={"date"}
                                                focused={false}
                                                isRequired={false}
                                                isDisabled={!values.type || values.type !== 'custom'}
                                                label={""}
                                                sizeval="medium"
                                                min={values?.startDate}
                                                values={values?.endDate}
                                                onChange={handleChange}

                                                error={
                                                    Boolean(touched.endDate) && errors.endDate
                                                }
                                                helperText={touched.endDate && errors.endDate}
                                            />
                                        </Grid>


                                    </Grid >
                                </div>

                                {values.type && <div className='card cretePlan p-4' style={{ marginLeft: '16px', marginRight: '16px' }}>
                                    <div className='row'>
                                        <div className='col-12 mb-4'>
                                            <Typography variant="h4" component="h4" sx={{ fontSize: '18px' }}>
                                                Details
                                            </Typography>
                                        </div>
                                        <div className='col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                            <div className='borderBox'>
                                                <Typography variant="h4" component="h4" sx={{ fontSize: '15px' }}>
                                                    Influencer benifits
                                                </Typography>
                                                <Box className='numbBox' component="form" noValidate autoComplete="off">
                                                    <div className='row g-3 align-items-center'>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                                                Paid Quota
                                                            </Typography>
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <NumberInput
                                                                name={"paid"}
                                                                isRequired={false}
                                                                type={"number"}
                                                                isDisabled={!values.type || values.type !== 'custom'}
                                                                onWheel={(e) => e.target.blur()}
                                                                focused={false}
                                                                label={("")}
                                                                sizeval="medium"
                                                                values={values.paid}
                                                                onChange={handleChange}

                                                                error={Boolean(touched.paid) && errors.paid}
                                                                helperText={touched.paid && errors.paid}
                                                            />
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                                                Barter Quota
                                                            </Typography>
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <NumberInput
                                                                name={"barter"}
                                                                isRequired={false}
                                                                type={"number"}
                                                                isDisabled={!values.type || values.type !== 'custom'}
                                                                onWheel={(e) => e.target.blur()}
                                                                focused={false}
                                                                label={("")}
                                                                sizeval="medium"
                                                                values={values.barter}
                                                                onChange={handleChange}

                                                                error={Boolean(touched.barter) && errors.barter}
                                                                helperText={touched.barter && errors.barter}
                                                            />
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                                                Affiliate Quota
                                                            </Typography>
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <NumberInput
                                                                name={"affiliate"}
                                                                isRequired={false}
                                                                type={"number"}
                                                                isDisabled={!values.type || values.type !== 'custom'}
                                                                onWheel={(e) => e.target.blur()}
                                                                focused={false}
                                                                label={("")}
                                                                sizeval="medium"
                                                                values={values.affiliate}
                                                                onChange={handleChange}

                                                                error={Boolean(touched.affiliate) && errors.affiliate}
                                                                helperText={touched.affiliate && errors.affiliate}
                                                            />
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <Typography variant="p" component="p" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.8)', fontWeight: '500', marginBottom: '0px' }}>
                                                                Performance Quota
                                                            </Typography>
                                                        </div>
                                                        <div className='col-md-6 col-sm-6 col-6'>
                                                            <NumberInput
                                                                name={"performance"}
                                                                isRequired={false}
                                                                type={"number"}
                                                                isDisabled={!values.type || values.type !== 'custom'}
                                                                onWheel={(e) => e.target.blur()}
                                                                focused={false}
                                                                label={("")}
                                                                sizeval="medium"
                                                                values={values.performance}
                                                                onChange={handleChange}

                                                                error={Boolean(touched.performance) && errors.performance}
                                                                helperText={touched.performance && errors.performance}
                                                            />
                                                        </div>
                                                    </div>

                                                </Box>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                }

                                <div className='card p-4' style={{ marginLeft: '16px', marginRight: '16px' }}>
                                    <div className='row'>
                                        <div className='col-12 d-flex align-items-center justify-content-end text-end'>
                                            <button className="btnSecondary" onClick={(e) => navigate("/subscriptions")}>Cancel</button>
                                            <button
                                                className="btnPrimary ms-2"
                                                type="submit"
                                            //disabled={!(isValid && dirty)}
                                            >
                                                Create Plan
                                            </button>
                                        </div>
                                    </div>
                                </div>


                            </Form >

                        </>
                    )}
                </Formik>
            </Paper >
        </>
    );
};

export default AddInfluencerSubscription;
